import $ from 'jquery'
import Splide from "@splidejs/splide";


const initializeBlock = function ($block) {
    var blockID = $block.attr('data-unique-id')

    var splide = new Splide('.js-steps-' + blockID, {
        arrows: false,
    });
    splide.mount();

    var imgsplide = new Splide('.js-steps-img-' + blockID, {
        pagination: false,
    });

    imgsplide.mount();

    if (splide && imgsplide) {
        splide.sync(imgsplide);

        const jsContainer = () => {
            var wrapper = $block.find('.steps-slider-block__images-wrapper');
            if (wrapper.length) {
                const bodyWidth = $('body').outerWidth()

                if (window.matchMedia('(min-width: 992px)').matches) {
                    wrapper.css({
                        width: `calc(${bodyWidth / 2}px`,
                        marginRight: `calc(${-bodyWidth / 2}px + 50%)`,
                        paddingRight: 0,
                    })
                } else {
                    wrapper.css({
                        width: `calc(${bodyWidth}px`,
                        marginRight: 0,
                    })
                }
            }
        }

        $(window).bind('resize', jsContainer).trigger('resize')
    }
}

$('.steps-slider-block').each(function () {
    initializeBlock($(this))
})

if (window.acf) {
    window.acf.addAction(
        'render_block_preview/type=autostrategy-steps-slider',
        initializeBlock
    )
}
